import {
    Box,
    Flex,
    Image, Portal,
    Text,
    useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import TrDashboardHeader from "../../../../components/common/TrainerDashboardHeader";
import TrainerSidenav from "../../../../components/trainer/courses/Sidenav";
import { QuestionTopicModal } from "../../../../components/trainer/modals/CreateQuestionTopic";
import quiz from '../../../../img/quiz.svg';
import theory from '../../../../img/theory.svg';
import ExportExcel from "../../../../utils/ExportExcel";


export const ExcelDataExport = [
    {
        'S/N': '1',
        'Question': 'What is your name?',
        'Option 1': 'olushola',
        'Option 2': 'vodina',
        'Option 3': 'ayo',
        'Option 4': 'kayode',
        'Option 5': 'Bolaji',
        'Correct Option': 'Option 3',
       
    }
]

const TrNewAssignment = () => {
    const navigate = useNavigate()
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [ass_topic, setAssTopic] = useState(false);
    const [ass_type, setAssType] = useState('');
    const [courseId, setCourseId] = useState('');
    const params = useParams();

    const course_id: any = params.course_id;
    useEffect(() => {
        if (course_id) {
            setCourseId(courseId)
        }
    }, [course_id])


    const openAssignmentTopic = async (typeA: string) => {
        setAssTopic(true)
        setAssType(typeA)
        onOpen();
    };
    return (
        <>
            <TrDashboardHeader />
            <Box bg='#F9F8F8' height='100vh' width="100%">
                <Flex width='90%' mx='auto' pt='80px' pb='150px'>
                    <TrainerSidenav />
                    <Box width='80%'>
                        <Box width='100%' mx='auto' pb='200px' px='50px' pt='50px' bg='white' >
                            <Flex justifyContent={'space-between'}>
                                <Text color='#1E1E1E' fontSize='28px' fontWeight='600'>Assessments</Text>
                                <ExportExcel title="Download Template" excelData={ExcelDataExport} fileName={'Quiz Question Template'} />
                            </Flex>
                            <Text color='#1E1E1E' fontSize='14px' fontWeight='600'>
                                Kindly download the Excel template to upload your quiz based questions
                            </Text>

                            <Flex mt='60px' px='160px' justifyContent='space-between' alignItems='center'>
                                <Box width='250px' cursor='pointer' onClick={() => { openAssignmentTopic('Quiz') }} py='60px' border='2px dashed' borderRadius='5px'>
                                    <Box mx='auto' width='55px'>
                                        <Image src={quiz} />
                                    </Box>
                                    <Text textAlign='center' color='#4F5175' mt='5px'>Upload Quiz</Text>

                                </Box>
                                <Text> Or</Text>
                                <Box width='250px' py='60px' border='2px dashed' cursor='pointer' onClick={() => { openAssignmentTopic('Theory') }} borderRadius='5px'>
                                    <Box mx='auto' width='55px'>
                                        <Image src={theory} />
                                    </Box>
                                    <Text textAlign='center' color='#4F5175' mt='5px'>Theory</Text>

                                </Box>
                            </Flex>

                        </Box>


                    </Box>
                </Flex>
                {ass_topic && (
                    <Portal> {" "}
                        <QuestionTopicModal
                            isOpen={isOpen}
                            onClose={onClose}
                            isQuestionTopic={ass_topic}
                            ass_type={ass_type}
                            courseId={course_id}

                        /> {" "}
                    </Portal>
                )}
            </Box>
        </>
    )
}

export default TrNewAssignment;